'use client';

import { useState } from 'react';
import CopyIcon from 'assets/icons/copy.svg';
import styles from './copy-to-clipboard.module.scss';
import Button from 'components/controls/buttons/button';
import trackClickButton, {
	type ClickButtonAnalyticsProps,
} from 'lib/analytics/trackClickButton';

const copyToClipboard = (text: string) => {
	if (
		typeof navigator !== 'undefined' &&
		typeof navigator?.clipboard?.writeText !== 'undefined'
	) {
		navigator.clipboard.writeText(text);
		return true;
	}
	return false;
};

interface IProps {
	text: string;
	message?: string; // TODO: storybook coverage
	analytics?: ClickButtonAnalyticsProps;
}

const CopyToClipboard = ({ text, analytics, message }: IProps) => {
	const [isCopied, setIsCopied] = useState(false);

	const handleCopy = () => {
		const success = copyToClipboard(text);
		setIsCopied(success);
		setTimeout(() => setIsCopied(false), 2000);

		if (success && analytics) {
			trackClickButton(analytics);
		}
	};

	return (
		<div className={styles.copyToClipboard}>
			{!isCopied && (
				<Button appearance="tertiary" onClick={handleCopy}>
					{!!message && message}
					{!message && (
						<>
							Copy to clipboard <CopyIcon className={styles.copyIcon} />
						</>
					)}
				</Button>
			)}
			{isCopied && (
				<div className={`${styles.confirmation} tertiary button`}>Copied ✓</div>
			)}
		</div>
	);
};

export default CopyToClipboard;
